<template>
  <div v-if="isDeveloperMode" :class="$style.wrapper">
    <VdIcon store="fa" name="download" size="small" />
    <span :class="{ [$style.sizeChangeUp]: operator === '+', [$style.sizeChangeDown]: operator === '-' }">
      {{ operator }}{{ cohortTotalOverridesGap.value }}{{ cohortTotalOverridesGap.unit }}
    </span>
  </div>
</template>
<script setup>
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { formatSize } from "@/utils/formatSize";
import { computed, inject } from "vue";
import { DEVELOPER_MODE } from "@/constants";

const isDeveloperMode = inject(DEVELOPER_MODE);
const props = defineProps({
  gapInSize: {
    type: Number,
    required: true,
  },
});

const cohortTotalOverridesGap = computed(() => formatSize(props.gapInSize));

const operator = computed(() => {
  const { isNegative, value } = cohortTotalOverridesGap.value;
  if (value === 0) {
    return "";
  }
  return isNegative ? "-" : "+";
});
</script>

<style module>
.sizeChangeUp {
  color: var(--vd-color-red-600);
}

.sizeChangeDown {
  color: var(--vd-color-green-600);
}

.wrapper {
  display: flex;
  flex-direction: row;
  gap: 1px;
  justify-content: start;
  justify-items: center;
  align-items: center;
}
</style>
